import { Box, useMediaQuery } from "@mui/material";
import { ReactNode } from "react";
import { Form, Stack } from "..";
import { useTheme } from "../../hooks";

export const Page = (props: { header?: ReactNode; tabs?: ReactNode; children?: ReactNode; isForm?: boolean }) => {
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up("sm"));

  const style: any = {
    position: "absolute",
    width: "100%",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 100,
    display: "flex",
    flexDirection: "column",
    background: theme.palette.background.default,
    overflow: "auto",
  };

  const renderContent = () => {
    return (
      <>
        {props.header && (
          <Box
            display="grid"
            alignItems={"center"}
            minHeight="50px"
            px={upSm ? 5 : 3}
            // fontSize="2.6rem"
            fontSize="1.6rem"
            //border={1}
            flexShrink={0}
            pt={3}
            pb={1}
          >
            {props.header}
          </Box>
        )}

        {props.tabs && (
          <Box sx={{ position: "sticky", top: 0, borderBottom: 1, borderColor: "divider", pl: 0, pr: 0, mb: 3}}>
            {props.tabs}
          </Box>
        )}

        <Box
          data-form-error-banner-slot="true"
          sx={{
            position: "sticky",
            top: 0,
            zIndex: theme.zIndex.appBar,
            px: upSm ? 5 : 3,
            backgroundColor: theme.palette.background.default,
          }}
        />

        {props.children && (
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              flexShrink: 1,
              overflow: "auto",

              px: upSm ? 5 : 3,
              pt: 1,
              pb: 3,
            }}
          >
            {props.children}
          </Box>
        )}
      </>
    );
  };

  return !props.isForm ? <Box style={style}>{renderContent()}</Box> : <Form style={style}>{renderContent()}</Form>;
};
